/* eslint react/prop-types: 0 */

import RowButton from 'components/atoms/row-button'
import PropTypes from 'prop-types'
import React from 'react'
import StringUtils from 'utils/string-util'
import { Badge } from 'reactstrap'

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

/**
 * Columns definition for Seller Product Table
 * @param {array} rowButtonProps - Array props for row button
 */
const exclusiveSellerProductTableColumns = ({
  buttonText,
  buttonColour,
  onButtonClick
}) => {
  const PriceCell = (row) => <div>{ StringUtils.currencyCase(row.cell.value ?? 0) }</div>

  const TextWrapCell = (row) => <div className='text-wrap'>{ row.cell.value }</div>

  const SellingPriceCell = (row) => <div className='text-danger'>{ StringUtils.currencyCase(row.cell.value ?? 0) }</div>

  const CommissionCell = ({ cell: { row } }) => {
    const calculationType = row.original.calculation_type
    if (calculationType === 'percentage') {
      return (
        <div> { row.original.commission }% </div>
      )
    } else {
      return (
        <div>{ StringUtils.currencyCase(row.original.commission ?? 0) }</div>
      )
    }
  }

  const InStockCell = (row) => {
    const inStock  = row.cell.value
    const colorMap = {
      'yes' : 'success',
      'no'  : 'danger'
    }
    return (
      <Badge
        className='badge-lg'
        color={ colorMap[inStock] }
      >
        { inStock }
      </Badge>
    )
  }

  const ActionCell = ({ cell: { row } }) => {
    const disabled = row.original.is_in_stock === 'no'

    return (
      <RowButton
        data={ row.original }
        color={ buttonColour }
        onClick={ onButtonClick }
        text={ buttonText }
        disabled={ disabled }
      />
    )
  }
  ActionCell.propTypes = actionCellPropTypes

  return (
    [
      {
        Header  : 'Seller',
        columns : [
          {
            Header   : 'Name',
            id       : 'seller_name',
            accessor : 'seller_name',
            Cell     : TextWrapCell
          },
          {
            Header   : 'Code',
            id       : 'seller_code',
            accessor : 'seller_code'
          }
        ]
      },
      {
        Header  : 'Seller Product',
        columns : [
          {
            Header   : 'SKU',
            accessor : 'sku'
          },
          {
            Header         : 'Name',
            accessor       : 'product_name',
            disableFilters : true,
            Cell           : TextWrapCell
          },
          {
            Header         : <>In<br/> Stock</>,
            accessor       : 'is_in_stock',
            disableFilters : true,
            Cell           : InStockCell
          },
          {
            Header         : 'Price',
            accessor       : 'price',
            disableFilters : true,
            Cell           : PriceCell
          },
          {
            Header         : <>Selling<br/> Price</>,
            accessor       : 'selling_price',
            disableFilters : true,
            Cell           : SellingPriceCell
          },
          {
            Header         : <>Seller <br/>Revenue <br/>Amount</>,
            accessor       : 'seller_revenue_amount',
            disableFilters : true,
            Cell           : PriceCell
          },
          {
            Header         : 'Commission',
            accessor       : 'commission',
            disableFilters : true,
            Cell           : CommissionCell
          }
        ]
      },

      {
        Header : 'Actions',
        Cell   : ActionCell
      }
    ]
  )
}

export default exclusiveSellerProductTableColumns
